"use client";
export const runtime = "edge";
import AboutSection from "@/components/aboutSection";
import WorksSection from "@/components/workSection";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";
import ProjectSec from "@/components/porject-sec";
import mainLogo from "@/public/mainLogo.png";
import AboutProjects from "./gallery/page";
import { FloatingNav } from "@/components/ui/FloatingNavbar";
import { useTranslatedData } from "@/data";
import Image from "next/image";
import trq_logo from "@/public/logo_glassmorphism.png";
import Link from "next/link";
import { Router } from "lucide-react";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
// import TestimonialSection from "@/components/testimonials";
import Counter from "@/components/counter";
import { ServiceCard } from "@/components/serviceCard";

/* Reusable Framer-Motion Counter */

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const containerStagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2, delayChildren: 0.1 } },
};

const NavbarHero = () => {
  const router = useRouter();
  const locale = useLocale();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState("");
  const { navItems } = useTranslatedData();
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: "-100px" });

  const partnerLogos = [
    "/partner-1.svg",
    "/partner-2.png",
    "/partner-3.png",
    "/partner-4.png",
    "/partner-5.png",
    "/partner-6.png",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }),
      );
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="app nh">
      {/* Hero Section */}
      <section className="black-hero-02 home">
        <FloatingNav />

        <div className="black-hero-container-02">
          <div className="hero-text-wrap-02">
            <div className="hero-title-02">
              <div className="overflow-hidden">
                <h2
                  className="heading-01"
                  style={{
                    color: "rgba(255, 255, 255, 0.5)",
                    backgroundImage: "linear-gradient(to top, black, white)", // bottom → top
                    WebkitBackgroundClip: "text",
                  }}
                >
                  Full-Service
                </h2>
              </div>
              <div className="home-hero-line-wrap">
                <div className="overflow-hidden">
                  <div className="home-hero-inline">
                    {/* Animated line */}
                    <motion.div
                      className="hero-line"
                      initial={{ width: 0 }}
                      animate={{ width: "60px" }}
                      transition={{ duration: 0.6, ease: "easeInOut" }}
                    />
                    {/* Animated word */}
                    <motion.h2
                      className="heading-01"
                      initial={{ x: -80, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeOut",
                        delay: 0.4,
                      }}
                      style={{
                        color: "transparent",
                        backgroundImage:
                          "linear-gradient(to top, black, white)", // bottom → top
                        WebkitBackgroundClip: "text",
                      }}
                    >
                      &nbsp;&nbsp;Digital
                    </motion.h2>
                  </div>
                </div>

                <div className="overflow-hidden">
                  <h2
                    className="heading-01"
                    style={{
                      color: "transparent",
                      backgroundImage: "linear-gradient(to top, black, white)", // bottom → top
                      WebkitBackgroundClip: "text",
                    }}
                  >
                    Agency
                  </h2>
                </div>
              </div>
            </div>

            <div className="hero-short-text-02">
              <div className="body-01">
                Transforming your digital presence with innovative web design
              </div>
            </div>
          </div>

          <div className="hero-bottom-02">
            <div className="item-box">
              <div className="circleX green"></div>
              <div className="sub-title">Riyadh, {currentTime}</div>
            </div>
            <div className="scroll-text-wrap">
              <div className="scroll-icon-wrap">
                <img
                  src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/6804b69a16f35964874c0550_Group%202147225222.svg"
                  loading="lazy"
                  alt=""
                  className="scroll-icon _01"
                />
                <img
                  src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/6804b69a16f35964874c0550_Group%202147225222.svg"
                  loading="lazy"
                  alt=""
                  className="scroll-icon _02"
                />
              </div>
              <div className="sub-title">Scroll Down</div>
            </div>
          </div>
        </div>

        {/* Background video */}
        <div className="home-hero-video w-background-video w-background-video-atom">
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              backgroundImage:
                "url('https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814%2F683d95447c690b9819164a07_freepik__smooth-flowing-motion-ethereal-wisps-of-smoke-grac__69084-poster-00001.jpg')",
            }}
          >
            <source src="/shutterstock_3529545287.mp4" type="video/mp4" />
            <source
              src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814%2F683d95447c690b9819164a07_freepik__smooth-flowing-motion-ethereal-wisps-of-smoke-grac__69084-transcode.webm"
              type="video/webm"
            />
          </video>
        </div>
      </section>
      <AboutSection />
      <WorksSection />
      <section className="partner">
        <div className="splash-stars"></div>
        <div className="splash-stars2"></div>
        <div className="splash-stars3"></div>
        <div className="parner-container-wrap">
          <div className="partner-container">
            <div className="section-header">
              <div className="section-heade-titile">
                <motion.div
                  id="partners"
                  className="heading-04"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  Our Partners -
                </motion.div>
              </div>
              <div className="section-header-text">
                <motion.div
                  className="heading-03"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  Trq Studio works with the industry's top platforms.
                </motion.div>

                {/* Stats with animated counters */}
                <motion.div
                  className="state-card-wrap"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  {/* Successful Projects */}
                  <div className="state-card-03">
                    <div className="statistics-number-wrap">
                      <Counter to={34} duration={1.4} className="heading-01" />
                    </div>
                    <div className="body-02 mt-10">Successful Project</div>
                  </div>

                  <div className="state-divider"></div>
                  {/* Client Satisfaction */}
                  <div className="state-card-03">
                    <div className="statistics-number-wrap">
                      <Counter
                        to={100}
                        duration={1.4}
                        suffix="%"
                        className="heading-01"
                      />
                    </div>
                    <div className="body-02 mt-10">
                      Client Satisfaction Rate
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="parner-logo-outer">
            <motion.div
              className="partner-logo-wrapper"
              animate={{ x: ["-55.855%", "-111.71%"] }}
              transition={{
                repeat: Infinity,
                duration: 30,
                ease: "linear",
              }}
            >
              {[...partnerLogos, ...partnerLogos].map((logo, index) => (
                <div key={`logo-${index}`} className="partner-logo-box">
                  <div className="partner-logo-inner">
                    <Image
                      src={logo}
                      alt="Partner logo"
                      className="partner-logo"
                      width={120}
                      height={60}
                    />
                  </div>
                </div>
              ))}
            </motion.div>
            <motion.div
              className="partner-logo-wrapper _01"
              animate={{ x: ["-55.855%", "-111.71%"] }}
              transition={{
                repeat: Infinity,
                duration: 30,
                ease: "linear",
              }}
            >
              {[...partnerLogos, ...partnerLogos].map((logo, index) => (
                <div key={`logo2-${index}`} className="partner-logo-box">
                  <div className="partner-logo-inner">
                    <Image
                      src={logo}
                      alt="Partner logo"
                      className="partner-logo filter invert brightness-0"
                      width={120}
                      height={60}
                    />
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
          <section className="service-01" ref={sectionRef}>
            <motion.div
              className="service-01-container"
              variants={containerStagger}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
            >
              <motion.div className="section-header" variants={fadeUp}>
                <div className="section-heade-titile">
                  <div className="heading-04">Services We Provide -</div>
                </div>
                <div className="section-header-text max-767">
                  <motion.div className="overflow-hidden" variants={fadeUp}>
                    <h2 className="heading-02 uper-case">Expert Services</h2>
                  </motion.div>
                  <motion.div className="overflow-hidden" variants={fadeUp}>
                    <h2 className="heading-02 uper-case">to Drive Success</h2>
                  </motion.div>
                </div>
              </motion.div>

              <motion.div className="service-grid" variants={containerStagger}>
                {/* Satisfaction Card */}
                <motion.div className="state-card-02 _02" variants={fadeUp}>
                  <div>
                    <div className="state-card-03">
                      <div className="statistics-number-wrap _03">
                        <Counter
                          to={100}
                          duration={1.4}
                          suffix="%"
                          className="heading-01"
                        />
                      </div>
                    </div>
                    <div className="body-02 mt-10">
                      Client Satisfaction Rate
                    </div>
                  </div>
                </motion.div>
                {/* Service Cards */}
                <motion.div variants={fadeUp}>
                  <ServiceCard
                    icon="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65836/67fc9fb5b2ae65e17cf9dae5_Style%3DStroke%2C%20Type%3DRounded.svg"
                    title="Branding"
                    description="We master the art of shaping a unique identity..."
                    link={`/${locale}/services/branding`}
                  />
                </motion.div>
                <motion.div variants={fadeUp}>
                  <ServiceCard
                    icon="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65836/67fc9fd52ea14342e38c6545_ai-brain-04.svg"
                    title="App Design"
                    description="We focus on creating user-friendly interfaces..."
                    link={`/${locale}/services/app-design`}
                  />
                </motion.div>
                <motion.div variants={fadeUp}>
                  <ServiceCard
                    icon="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65836/67fca0a883eecfa712fc3095_ai-laptop.svg"
                    title="Web Design"
                    description="Streamline processes with AI-powered HR solutions..."
                    link={`/${locale}/services/web-development`}
                  />
                </motion.div>
                <motion.div variants={fadeUp}>
                  <ServiceCard
                    icon="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65836/680c92c24508a8078761ff49_command-line.svg"
                    title="Development"
                    description="Turning design concepts into functional software."
                    link={`/${locale}/services/development`}
                  />
                </motion.div>

                {/* Contact Card */}
                <motion.div className="contact-card" variants={fadeUp}>
                  <div className="body-03 gray-color">
                    Enable businesses to thrive online by delivering tailored
                    web development
                  </div>
                  <div className="service-btn-wrap">
                    <div className="secondary-btn-wrap">
                      <Link
                        href={`/${locale}/services`}
                        className="secondary-btn"
                      >
                        <div className="primary-btn-inner">
                          <div className="btn-text-wrap">
                            View All Services
                            <p className="sub-title-semibold hover">
                              View All Services
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            </motion.div>
          </section>
        </div>
      </section>
      <style jsx>{`
        .hero-line {
          display: inline-block;
          height: 3px;
          background: #fff;
          margin-right: 10px;
          transform-origin: left;
        }
      `}</style>
      <section className="footer-cta">
        <motion.div
          className="footer-cta-container"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <div className="cta">
            <h2 className="heading-01">Let&apos;s work Together</h2>
            <Link
              href="/contract-us"
              className="cta-float-wrap w-inline-block w--current"
            >
              <div className="cta-float">
                <Image
                  src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/67d7308c4eb472a0833d503b_arrow-down-01.svg"
                  alt=""
                  className="cta-float-icon"
                  width={20}
                  height={20}
                />
              </div>
            </Link>
          </div>

          {/* Dark footer content */}
          <motion.div
            className="footer-dark"
            variants={containerStagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
          >
            <div className="footer-container">
              <div className="footer-wrapper">
                <motion.div className="footer-left" variants={fadeUp}>
                  <Link href="/" className="footer-brand w-inline-block">
                    <Image
                      src="/trq_liquid.webm"
                      alt="logo"
                      height={70}
                      width={70}
                    />
                  </Link>
                  <div className="body-03 mt-20 gray-color">
                    Connect with us:
                  </div>
                  <div className="footer-social-block">
                    <a
                      href="https://dribbble.com/"
                      target="_blank"
                      className="footer-social-link w-inline-block"
                    >
                      <img
                        src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/67d730aa155b1f0c122f2b39_dribble%201.svg"
                        loading="lazy"
                        alt=""
                        className="social-icon"
                      />
                    </a>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      className="footer-social-link w-inline-block"
                    >
                      <img
                        src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/67d73095c435083e21c1093d_dribble%201.svg"
                        loading="lazy"
                        alt=""
                        className="social-icon"
                      />
                    </a>
                    <a
                      href="https://x.com/"
                      target="_blank"
                      className="footer-social-link w-inline-block"
                    >
                      <img
                        src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/67d730aa51a3e92332577377_twitter.svg"
                        loading="lazy"
                        alt=""
                        className="social-icon"
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      className="footer-social-link w-inline-block"
                    >
                      <img
                        src="https://cdn.prod.website-files.com/67c3581ddb64922e2ab65814/67d738d1155b1f0c1234fc90_Group%202147225221.svg"
                        loading="lazy"
                        alt=""
                        className="social-icon"
                      />
                    </a>
                  </div>
                </motion.div>

                <div className="footer-content">
                  <motion.div className="footer-block" variants={fadeUp}>
                    <div className="heading-04">Pages</div>
                    <Link href="/" className="footer-link">
                      Home
                    </Link>
                    <Link href="/about-us" className="footer-link">
                      About Us
                    </Link>
                    <Link href="/service" className="footer-link">
                      Our Service
                    </Link>
                    <Link href="/work" className="footer-link">
                      Our Works
                    </Link>
                    <Link href="/blog" className="footer-link">
                      Blog
                    </Link>
                    <Link
                      href="/contract-us"
                      className="footer-link w--current"
                    >
                      Contact us
                    </Link>
                  </motion.div>

                  <motion.div className="footer-block" variants={fadeUp}>
                    <div className="heading-04">Utility Pages</div>
                    <a href="/404" className="footer-link">
                      404
                    </a>
                    <a href="/reference/style-guide" className="footer-link">
                      Styleguide
                    </a>
                    <a href="/reference/license" className="footer-link">
                      License
                    </a>
                    <a href="/reference/changelog" className="footer-link">
                      Changelog
                    </a>
                    <a href="/401" className="footer-link">
                      Password
                    </a>
                  </motion.div>

                  <motion.div className="footer-block _03" variants={fadeUp}>
                    <div className="contact-block gray-color"></div>
                    <div className="contact-block gray-color">
                      <div className="body-02">Email:</div>
                      <a
                        href="mailto:info@trq-agency.com"
                        className="contact-link hover-effect"
                      >
                        info@trq-agency.com
                      </a>
                    </div>
                  </motion.div>
                </div>
              </div>

              <motion.div className="footer-divider" variants={fadeUp} />

              <motion.div className="footer-bottom" variants={fadeUp}>
                <div className="footer-copyright-center">
                  Copyright 2025. All rights reserved. Powered by{" "}
                  <a
                    href="https://trq-agency.com/"
                    target="_blank"
                    className="privacy-terms-link"
                  >
                    TRQ-Agency LTD
                  </a>
                  .
                </div>
                <div className="privacy-terms-wrap">
                  <a href="/privacy-policy" className="privacy-terms-link">
                    Privacy Policy
                  </a>
                  <div>|</div>
                  <a href="/terms" className="privacy-terms-link">
                    Terms of Conditions
                  </a>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    </div>
  );
};

export default NavbarHero;
